"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
__export(require("./vanilla/index"));
//# sourceMappingURL=vanilla.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib/vanilla.js
// module id = 430
// module chunks = 1